import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import personnelSlice from "./component/Personnel/PersonnelSlice";
import DepartmentSlice from "./component/Department/DepartmentSlice";
import AbsenteeismSlice from "./component/Absenteeism/AbsenteeismSlice";
import DepStatisticsSlice from "./component/DepStatistics/DepStatisticsSlice";
import DepStaDetailsSlice from "./component/DepStaDetails/DepStaDetailsSlice";
import ManageDepSlice from "./component/ManageDepartment/ManageDepSlice";
import ManageEmpSlice from "./component/ManageEmployee/ManageEmpSlice";
import UserSlice from "./component/User/UserSlice";
import AttendanceByNameSlice from "./component/AttendanceByName/AttendanceByNameSlice";
import AttendanceMonthlySlice from "./component/AttendanceMonthly/AttendanceMonthlySlice";

export default configureStore({
  reducer: {
    personnelSlice: personnelSlice,
    DepartmentSlice: DepartmentSlice,
    AbsenteeismSlice: AbsenteeismSlice,
    DepStatisticsSlice: DepStatisticsSlice,
    DepStaDetailsSlice: DepStaDetailsSlice,
    ManageDepSlice: ManageDepSlice,
    ManageEmpSlice: ManageEmpSlice,
    UserSlice: UserSlice,
    AttendanceByNameSlice: AttendanceByNameSlice,
    AttendanceMonthlySlice: AttendanceMonthlySlice,
    },
  middleware: [thunk],
});
